<template>
  <hic-table :condition="myCondition" :entities="entities" @load="page" :loading="loading">
    <el-table-column align="center" label="操作" width="100px;">
      <template slot-scope="{row}">
      <el-button  v-if="!row.disabled" type="danger" size="mini" @click.native="refund(row)">退 费</el-button>

        <!-- <el-button v-if="!row.disabled" @click.native="refund(row)" icon="el-icon-close" size="mini" circle type="danger" title="退费"></el-button> -->
        <!-- <el-tag v-else type="danger">已退费</el-tag> -->
      </template>
    </el-table-column>
    <el-table-column align="center" width="50" type="index" label="序号">
      <template #default="scope">
        <span>{{ entities.index * entities.size + scope.$index + 1 }}</span>
      </template>
    </el-table-column>
    <template v-if="!isEmbed">
      <el-table-column label="床位号" align="left" prop="bedNo" sortable="custom" width="100"
        key="bedNo"></el-table-column>
      <el-table-column label="患者" prop="patientName" align="left">
        <template #default="{ row }">
          <span class="sub-title">{{ row.patientName }} </span>
        </template>
      </el-table-column>
    </template>
    <el-table-column label="类别" align="center" prop="rpClass" width="100" :filters="dictEnum.RpClass"
      column-key="rpClass" :filter-multiple="false" sortable="custom"> </el-table-column>
    <el-table-column label="项目名称" align="left" prop="name" min-width="150">
      <template #default="{ row }"> <el-tag v-if="row.disabled" type="danger" size="mini" hit>已退费</el-tag> {{ row.name
        }}</template>
    </el-table-column>
    <el-table-column label="规格" align="left" prop="standard" min-width="100"> </el-table-column>
    <el-table-column label="单价" align="right" prop="price"> </el-table-column>
    <el-table-column label="数量" align="right" prop="quantity">
      <template #default="{ row }"> {{ row.quantity | fmtFloat }} {{ row.unit }} </template>
    </el-table-column>
    <el-table-column label="金额" align="right" prop="totalPrice">
      <template #default="{ row }">
        <span class="danger">{{ (row.price * row.quantity) | fmtFloat }}</span>
      </template>
    </el-table-column>

    <el-table-column label="医保类别" align="center" prop="claimType" width="100"> </el-table-column>
    <el-table-column label="医生" align="center" prop="doctorName" width="100"> </el-table-column>
    <!-- <el-table-column label="科室" align="center" prop="" width="100">
      <template #default="{ row }">
        {{ row.deptCode | dictText("Dept") }}
      </template>
    </el-table-column> -->
    <el-table-column label="记账日期" align="center" prop="" width="100">
      <template #default="{ row }">
        {{ row.billingDate | fmtDate }}
      </template>
    </el-table-column>
    <el-table-column label="执行科室" align="center" prop="execDeptCode" width="150" :filters="dict.Dept"
      column-key="execDeptCode" :filter-multiple="false" sortable="custom">
      <template #default="{ row }">
        {{ row.execDeptCode | dictText("Dept") }}
      </template>
    </el-table-column>
  </hic-table>
</template>

<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  props: {
    condition: Object,
  },
  data() {
    return {
      loading: false,
      myCondition: {
        pageIndexOnView: 1,
        pageSize: 20,
        keyword: null,
        hospitalizationId: null,
      },
      entities: {},
    };
  },
  computed: {
    ...mapGetters(["dictEnum", "dict","user"]),
    isEmbed() {
      // 是否是嵌入模式
      return this.$route.path != "/fee";
    },
  },
  watch: {
    condition() {
      this.page();
    },
  },
  mounted() {
    this.page();
  },
  methods: {
    page() {
      this.loading = true;
      this.myCondition.keyword = this.condition.keyword;
      if (this.condition.patient) {
        this.myCondition.hospitalizationId = this.condition.patient.id;
      } else {
        this.myCondition.hospitalizationId = null;
      }
      this.loading = true;
      api.Billing.query(this.myCondition)
        .then((res) => {
          this.entities = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    refund(row) {
      this.$prompt(
        '请输入退费原因：',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: "warning",            // 图标样式 "warning"|"error"...
          inputValue: '',
          inputErrorMessage: '输入不能为空',
          inputValidator: (value) => {       // 点击按钮时，对文本框里面的值进行验证
            if (!value) {
              return '输入不能为空';
            }
          }
        }).then(({ value }) => {
          this.loading = true;
          this.$set(row, 'disabled', true)
          this.$set(row, 'refundNurseCode', this.user.id)
          this.$set(row, 'refundNurseName', this.user.name)
          this.$set(row, 'refundTime', this.$utils.Dt.now())
          this.$set(row, 'refundReason', value)
          api.Billing.save(row)
            .then((res) => {
              this.loading = false;
              this.$message.success("退费成功");
              this.page();
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error(err);
            });
        }).catch((err) => {
          console.log(err);
        });
    }
  },
};
</script>
